import PropTypes from 'prop-types';
import { Table } from '../../../../../common/components';
import { formatDate, formatPrice } from '../../../../../utils/formatters';

const CommonComponentForTableData = ({ pageData, headers, slStartNumber }) => {
  if (!pageData || pageData.length === 0) {
    return null;
  }

  return (
    <Table bordered responsive className="trustaccounts-table">
      <tbody>
        <tr className="table-body-row">
          <th className="trustaccounts-table">S.NO</th>
          {headers.map((header) => (
            <th key={header.headerValue} className="trustaccounts-table">
              {header.headerText}
            </th>
          ))}
        </tr>
        {pageData.map((item, index) => (
          <tr key={item['S.NO'] || index} className="table-body-row">
            <td>{slStartNumber + index + 1}</td>
            {headers.map((header) => {
              let cellContent = '';
              switch (header.type) {
                case 'date':
                  cellContent = formatDate(item[header.headerValue] || 0);
                  break;
                case 'price':
                  cellContent = formatPrice(item[header.headerValue] || 0);
                  break;
                case 'boolean':
                  cellContent = item[header.headerValue] === 1 ? 'Yes' : 'No';
                  break;
                case 'number':
                  cellContent = item[header.headerValue];
                  break;
                default:
                  cellContent =
                    item[header.headerValue] !== 'NA' ? item[header.headerValue] || '-' : '-';
                  break;
              }
              return <td key={header.headerValue}>{cellContent}</td>;
            })}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

CommonComponentForTableData.propTypes = {
  pageData: PropTypes.arrayOf(PropTypes.object).isRequired,
  headers: PropTypes.arrayOf(
    PropTypes.shape({
      headerValue: PropTypes.string.isRequired,
      // Remove headerText from here
    }),
  ).isRequired,
  slStartNumber: PropTypes.number.isRequired,
};

export default CommonComponentForTableData;
